<template>
  <div class="validation-wrapper">
    <h2>
      Validating access.
    </h2>

    <h2>
      Please wait...
    </h2>

    <Loader />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-2'

export default {
  name: 'visitor-validation',

  components: {
    Loader,
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    ...mapActions(['executeSurveyAPICall', 'setIsVisitorAccess']),

    async validate() {
      const { visitor, survey } = this.$route.query

      const confirmation = await this.executeSurveyAPICall({
        method: 'GET',
        path: 'visitor-validation',
        queryParams: { visitor, survey },
      })

      if (!confirmation) return this.$router.push('/login')

      this.setIsVisitorAccess(true)

      this.$router.push({ name: 'report', query: this.$route.query })
    },
  },

  mounted() {
    this.validate()
  },
}
</script>

<style lang="scss" scoped>
.validation-wrapper {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

h2 {
  color: $gray-7;
  font-size: rem(24);
  font-weight: 600;
  text-align: center;

  & + & {
    margin-top: 12px;
  }
}
</style>
